@use "../../../../tti-design-styles/src/organisms/footer/" as *;
